// import DOMPurify from 'dompurify';
// import { dissocPath } from 'lodash/fp';
// import {
//   isProductType,
// } from '@motionelements/core/src/services/catalog.service.js';
// import notificationService from '@motionelements/core/src/services/notification.service';
// import { getJobStatus } from '@motionelements/core/src/services/job.service.js';
import Vue from 'vue';
// import * as appApi from '@/api/app.js';
// import * as elementsApi from '../../../api/artist/elements';
import * as collectionApi from '../../../api/artist/collections';
// import * as templatesApi from '../../../api/artist/templates-edit';
// import * as categoriesApi from '../../../api/categories';
// import musicalKeys from './musicalKey';
// import instruments from './instruments';

Vue.prototype.$hasOwnProp = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);

const state = {
  // from query string in url (camelCase)
  query: '',
  // filters
  filters: {
  },
  querys: {
    // q: '',
    sort: '',
    // media_type: '',
    // page: 1,
    // per_page: 10,
    status: '',
    // exclusive: '',
    // model_release: '',
    // property_release: '',
  },
  loading: false,
  sidebarStatus: false,
  // element: null,
  // elementForm: {},
  collection: null,
  collectionItems: [],
  collectionForm: {},
  tabs: {
    basic: {
      validators: [],
    },
    elements: {
      validators: [],
    },
    // optional: {
    //   validators: [],
    // },
  },
  itemTableColumns: [
    'id',
    'name',
    // 'exclusive',
    // 'subscription',
    // 'url',
    // 'media_type',
    // 'artist',
    'price',
    'previews',
    'thumbnails',
    // 'custom_id',
    // 'versions',
    'status',
    'added_at',
    'published_at',
    // 'templates',
    // 'created_at',
  ],
  // subTabs: {
  //   fixed: {
  //     validators: [],
  //   },
  //   discount: {
  //     validators: [],
  //   },
  // },
  // taxonomy: {
  //   categories: null,
  //   styles: null,
  //   moods: null,
  //   genres: null,
  //   types: null,
  // },
  // priceTemplates: null,
  // software: null,
  // instruments: [],
  // musicalKeys: [],
  // metadataTemplates: null,
};

const blankCollection = {
  name: '',
  description: '',
  price: 0,
  priceOriginal: 0,
  status: 'draft',
};

const getters = {
  querys: state => state.querys,
  // elementForm: ({ elementForm }) => elementForm,
  collection: ({ collection }) => collection,
  collectionItems: ({ collectionItems }) => collectionItems,
  collectionForm: ({ collectionForm }) => collectionForm,
  sidebarStatus: ({ sidebarStatus }) => sidebarStatus,
  // file: ({ element: { variants } }) => (variants.length ? variants[0].file : null),
  //
  // getElementKey: ({ element }) => key => element[key],
  //
  // isVideo: ({ element }) => isProductType('video', element.mediaType),
  // tabs Errors
  getTabError: state => tabName => (state.tabs[tabName].validators.find(x => x.v.$error !== false)),
  // getSubTabError: state => tabName => (state.subTabs[tabName].validators.find(x => x.v.$error !== false)),
};

const mutations = {
  addCollectionFormField({ collectionForm }, { field, value }) {
    Vue.set(collectionForm, field, value);
  },
  // addElementVariantFormField({ element, collectionForm }, { sku, field, value }) {
  //   const variant = element.variants.find(x => x.id === sku);
  //   if (!variant) {
  //     // invalid variant
  //     return;
  //   }
  //   const formVariants = _.get(collectionForm, 'variants') || {};
  //   _.set(formVariants, [sku, field], value);
  //   Vue.set(collectionForm, 'variants', formVariants);
  // },
  // setElement(state, payload) {
  //   state.element = payload;
  // },
  // setElementKey({ element }, { key, value }) {
  //   Vue.set(element, key, value);
  // },
  setCollection(state, payload) {
    console.log('set collection: ', payload);
    state.collection = payload;
  },
  setCollectionItems(state, payload) {
    // console.log('setCollectionItems: ', payload);
    state.collectionItems = payload;
  },
  setLoading(state, status) {
    state.loading = status;
  },
  // SIDEBAR
  setSidebar(state, status) {
    state.sidebarStatus = status;
  },
  toggleSidebar(state) {
    state.sidebarStatus = !state.sidebarStatus;
  },
  // BASIC
  // setPriceTemplates(state, payload) {
  //   state.priceTemplates = payload;
  // },
  // taxonomy
  // setCategories(state, payload) {
  //   state.taxonomy.categories = payload;
  // },
  // setMoods(state, payload) {
  //   state.taxonomy.moods = payload;
  // },
  // setGenres(state, payload) {
  //   state.taxonomy.genres = payload;
  // },
  // setTypes(state, payload) {
  //   state.taxonomy.types = payload;
  // },
  // setInstruments(state, instruments) {
  //   state.instruments = instruments;
  // },
  //
  // setThumb({ element }, url) {
  //   element.thumbnails.jpg.url = url;
  // },
  // setVideoPreview({ element }, { ext, url }) {
  //   element.previews[ext] = url ? { url } : false;
  // },
  // toggleCategory({ element: { categories } }, category) {
  //   const index = categories.findIndex(item => item.id === category.id);
  //   index > -1 ? categories.splice(index, 1) : categories.push(category);
  // },
  // removeCategory({ element: { categories } }, index) {
  //   categories.splice(index, 1);
  // },
  // OPTIONAL
  // addKeyword({ element: { keywords } }, keyword) {
  //   keywords.push(keyword);
  // },
  // removeKeyword({ element: { keywords } }, index) {
  //   keywords.splice(index, 1);
  // },
  // setStyles(state, payload) {
  //   state.taxonomy.styles = payload;
  // },
  // setName({ collectionForm }, string) {
  //   console.log('artistCollectionEdit/setName: ', string);
  //   collectionForm.name = string;
  // },
  // setDescription({ collectionForm }, html) {
  //   console.log('artistCollectionEdit/setDescription: ', html);
  //   collectionForm.description = DOMPurify.sanitize(html);
  // },
  setCollectionField(state, { field, value }) {
    state.collection[field] = value;
  },
  setCollectionFormField({ collectionForm }, { field, key, value }) {
    if (Vue.prototype.$hasOwnProp(collectionForm, field)) {
      console.log('hasownprop', field, value);
      collectionForm[field][key] = value;
    } else {
      Vue.set(collectionForm, field, { [key]: value });
    }
  },
  // tabs Errors
  updateTabValidators({ tabs }, {
    tab,
    name,
    v,
    id,
  }) {
    const validator = tabs[tab].validators.find(x => x.name === name);
    if (validator) {
      validator.v = v;
    } else {
      tabs[tab].validators.push({ name, v, id });
    }
    // _.set(tabs[tab], ['validators', name], v);
  },
  removeTabValidator({ tabs }, { tab, id }) {
    const index = tabs[tab].validators.findIndex(item => item.id === id);
    if (index > -1) tabs[tab].validators.splice(index, 1);
  },
  saveDraft(state, status) {
    state.saveDraft = status;
  },
  reset(state) {
    console.log('reset CollectionEdit');
    state.collection = null;
    state.collectionForm = {};
    state.collectionItems = [];
    state.tabs.basic.validators = [];
    // state.tabs.elements.validators = [];
  },
  setQuery(state, query) {
    console.log('setQuery', query);
    state.query = query;
  },
};

const actions = {

  getCollectionList(params) {
    console.log('getCollectionList action', params);
    return collectionApi.listCollections(params)
      .then((response) => {
        console.log(response);
      });
  },

  setCollectionFormField({ commit }, { field, value }) {
    // commit('setElementKey', {
    //   key: field,
    //   value: value,
    // });

    switch (field) {
      // map taxonomy ids
      case 'categories':
      // case 'genres':
      // case 'moods':
      // case 'styles':
      // case 'types':
        value = value.map(item => item.id);
        break;
        // case 'variants':
        //   value = this.variantsFormField(value);
        //   break;
      default:
        break;
    }
    console.log(`UPDATE FORM_FIELD ${field}: ${value}`);
    commit('addCollectionFormField', { field, value });
  },
  setCollectionField({ commit }, { field, value }) {
    commit('setCollectionField', { field, value });
  },

  // setElementVariantFormField({ commit }, { sku, field, value }) {
  //   commit('addElementVariantFormField', { sku, field, value });
  // },

  getCollectionAction(state, collectionId) {
    // console.log('get collection action: ', collectionId);
    // fields[element]=edit
    const params = {
      'fields[elements]': 'edit',
    };

    collectionApi.getCollection(collectionId, params)
      .then(({ data: { data } }) => {
        console.log('get collection', data);
        state.commit('setCollection', data);
        // state.dispatch('getSoftwareVersion', data.mediaType);
      });
  },

  setCollectionBlank(state) {
    const data = { ...blankCollection };
    state.commit('setCollection', data);
  },

  getCollectionItems(state, { collectionId, params }) {
    console.log('getCollectionItems: ', collectionId, params);
    // query add item table columns
    const query = params || {};
    query['fields[element]'] = state.state.itemTableColumns.join(',');
    collectionApi.getCollectionItems(collectionId, query)
      .then(({ data: { data } }) => {
        console.log('get collection items', data);
        state.commit('setCollectionItems', data);
        // state.dispatch('getSoftwareVersion', data.mediaType);
      });
  },

  addCollectionItems({ dispatch }, { collectionId, elementId }) {
    console.log('addCollectionItems', { collectionId, elementId });
    return collectionApi.addCollectionItems(collectionId, elementId)
      .then((response) => {
        console.log('add collection items', response);
        dispatch('getCollectionItems', { collectionId: collectionId });
        return response;
      });
  },

  removeCollectionItem({ dispatch }, { collectionId, elementId }) {
    console.log('removeCollectionItem', { collectionId, elementId });
    return collectionApi.removeCollectionItem(collectionId, elementId)
      .then((response) => {
        console.log('remove collection items', response);
        dispatch('getCollectionItems', { collectionId: collectionId });
        return response;
      });
  },

  removeCollectionItems({ dispatch }, { collectionId, skus }) {
    console.log('removeCollectionItems', { collectionId, skus });
    return collectionApi.removeCollectionItems(collectionId, skus)
      .then((response) => {
        console.log('remove collection items', response);
        dispatch('getCollectionItems', { collectionId: collectionId });
        return response;
      });
  },

  createCollection({ commit }, data) {
    console.log('createCollection: ', data);
    return collectionApi.createCollection(data)
      .then((response) => {
        // console.log(response);
        commit('setLoading', false);
        return response;
      });
  },

  updateCollection({ commit }, { collectionId, data }) {
    console.log('updateCollection: ', collectionId, data);
    return collectionApi.updateCollection(collectionId, data)
      .then((response) => {
        console.log(response);
        commit('setLoading', false);
        return response;
      });
  },

  deleteCollection({ commit }, collectionId) {
    console.log('deleteCollection: ', collectionId);
    return collectionApi.deleteCollection(collectionId)
      .then((response) => {
        console.log(response);
        commit('setLoading', false);
        return response;
      });
  },

  publishCollection({ dispatch }, collectionId) {
    console.log('publishCollection action', collectionId);
    return collectionApi.publishCollection(collectionId)
      .then((response) => {
        console.log(response);
        dispatch('getCollectionAction', collectionId);
        // const data = response.data.data;
        // const element = { ...state.element };
        // element.status = data.status;
        // element.publishedAt = data.publishedAt;
        // commit('setCollection', data);
        return response;
      });
  },

  unpublishCollection({ dispatch }, collectionId) {
    console.log('publishElements action', collectionId);
    return collectionApi.unpublishCollection(collectionId)
      .then((response) => {
        console.log(response);
        dispatch('getCollectionAction', collectionId);
        // const data = response.data.data;
        // const element = { ...state.element };
        // element.status = data.status;
        // commit('setCollection', data);
        return response;
      });
  },

  // setQuery({ commit }, query) {
  //   // const filters = {};

  //   // if (query.status) {
  //   //   filters.status = query.status;
  //   // }

  //   // if (query.exclusive) {
  //   //   filters.exclusive = query.exclusive;
  //   // }

  //   // if (query.category) {
  //   //   filters.category = query.category;
  //   // }

  //   // if (query.collection) {
  //   //   filters.collection = query.collection;
  //   // }

  //   // commit('setFilters', filters);
  //   commit('setQuery', query);
  // },
  // addElementPreview(state, { collectionId, url }) {
  //   const params = { url };
  //   return elementsApi.addElementPreview(collectionId, params)
  //     .then(response => {
  //       console.log(response);
  //       return response;
  //     });
  // },
  // addElementPreviewMusic(state, { collectionId, url }) {
  //   const params = { url };
  //   return elementsApi.addElementPreviewMusic(collectionId, params)
  //     .then(response => {
  //       console.log(response);
  //       return response;
  //     });
  // },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
